import { MODULES_ENUM } from "types/enums/ModulesEnum";


export const isAllModulesAllowed = () => (window as any).externalConfig._allowed_module === MODULES_ENUM.ALL;